export {};
//# sourceMappingURL=exclude-metadata.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/class-transformer/esm5/interfaces/metadata/exclude-metadata.interface.js
// module id = 796
// module chunks = 3